// The menu's chat dot: unread messages in the community chat, asked once a minute while the menu
// shows and the page is in view (never in a round: the menu isn't drawn then). The chat itself
// loads only when opened; this is one small read.
import { useEffect, useState } from 'react';
import { api } from './api';

export const CHAT_DOT_MS = 60_000;

/** Unread rooms and DMs together (0 when off, or when the read fails). */
export function useChatUnread(on: boolean): number {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!on) {
      setN(0);
      return;
    }
    let live = true;
    const ask = () => {
      if (document.visibilityState !== 'visible') return;
      api
        .chatUnread()
        .then((u) => live && setN(u.rooms + u.dms))
        .catch(() => undefined);
    };
    ask();
    const t = setInterval(ask, CHAT_DOT_MS);
    document.addEventListener('visibilitychange', ask);
    return () => {
      live = false;
      clearInterval(t);
      document.removeEventListener('visibilitychange', ask);
    };
  }, [on]);
  return n;
}
